<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'students'
    }
</script>

<style lang="scss" scoped>

</style>